(ns frontend.ui.component.burger-menu.view
  (:require
   ["react-burger-menu" :rename {slide SlideMenu}]
   [re-frame.core :as rf]
   [herb.core :refer [<class]]
   [frontend.ui.component.burger-menu.style :as style]
   [frontend.ui.component.icon.view :refer [icon]]))

(defn burger-menu
  "list of items
  {:id optional id
   :href optional href - will be stopped by on-click handler
   :dispatch re-frame dispatch params
   :hiccup menu hiccup for rendering}"
  [{:keys [items right? width]}]
  [:div
   [:>
    SlideMenu
    (merge
     {:styles           (style/menu)
      :itemClassName    (<class style/item)
      :customBurgerIcon (reagent.core/as-element [icon :bars])}
     (when right?
       {:right true})
     (when width
       {:width width}))
    (->> items
         (map (fn [item]
                [:a
                 (merge {:id   (:id item)
                         :key  (:id item)
                         :href (or (:href item)
                                   "#")}
                        (when-let [target (:target item)]
                          {:target target}))
                 (:hiccup item)]))
         (doall))]])
